import { all, call } from 'redux-saga/effects'
import bookingRoot from './bookingSagas'
import busRoot from './busSagas'
import appRoot from './appSagas'
import errorRoot from './catchErrorSaga'

export default function* root() {
  yield all([call(appRoot), call(bookingRoot), call(busRoot), call(errorRoot)])
}
